import * as React from 'react'

const Base = ({ items }) => {
    return (
        <>
            {items}
        </>
    )
}
export default Base;